<template>
  <div class="page" data-page :class="{'in-transition':inTransition}">
    <transition name="page" @enter="mainRouterEnter" @beforeEnter="mainRouterBeforeEnter">
      <!-- <transition name="main"> -->
      <!-- <router-view class="page__main main" :key="$route.path" /> -->
      <router-view class="page__main main" />
    </transition>
    <page-footer class="page__footer" />
  </div>
</template>

<script>
import PageFooter from '@/partials/PageFooter'

import anime from 'animejs'

export default {
  name: 'AppPage',
  data() {
    return {
      inTransition: false
    }
  },
  components: {
    PageFooter
  },
  methods: {
    mainRouterBeforeEnter(el) {
      this.inTransition = true
    },
    mainRouterEnter(el, done) {
      anime({
        duration: 0,
        targets: '[data-page]',
        easing: 'linear',
        elasticity: 0,
        scrollTop: 0
      })
      anime({
        targets: el,
        opacity: [0, 1],
        duration: 500,
        easing: 'easeOutQuad',
        elasticity: 0,
        complete: () => {
          this.inTransition = false
          done()
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/partials/AppPage.vue